export class MemberNewsRequest {
    articleTitle: string;
    articleContent: string;
    postingAs: string;
    mainImageId: string;
    attachmentIds: string[];
    articleType: number;
    runDate: Date | undefined;

    constructor(title: string,
        content: string,
        postingAs: string,
        mainImageId: string,
        attachmentIds: string[],
        articleType: number,
        runDate: Date | undefined
    ) {
        this.articleTitle = title;
        this.articleContent = content;
        this.postingAs = postingAs;
        this.mainImageId = mainImageId;
        this.attachmentIds = attachmentIds;
        this.articleType = articleType;
        this.runDate = runDate;
    }
}